var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCross = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#BECCD8"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.698.264a.968.968 0 0 0-1.262-.062L10.329.3 6.002 4.857 1.671.3A.968.968 0 0 0 .175 1.524l.091.112 4.14 4.362-4.138 4.357A.975.975 0 0 0 .3 11.73a.962.962 0 0 0 1.255.067l.11-.1 4.337-4.569 4.333 4.57a.962.962 0 0 0 1.25.126l.11-.09c.356-.341.4-.88.128-1.267l-.09-.112L7.6 6l4.134-4.363a.97.97 0 0 0-.036-1.372z",
  fillRule: "evenodd"
})));

export default SvgCross;